<div class="loan-purpose-summary-component">
  @if (loanPurpose) {
    @if (hasAdditionalFields) {
      <div class="row" [ngClass]="{'needPadding': needPadding}">
        <!-- Loan Purpose (always first) -->
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Loan Purpose</div>
            <div body>{{loanPurpose.name}}</div>
          </cell>
        </div>
        
        <!-- Loan Purpose Description -->
        @if (loanPurpose.purposeDescription) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Loan Purpose Description</div>
              <div body>
                <span [title]="loanPurpose.purposeDescription" [innerHTML]="loanPurpose.purposeDescription"></span>
              </div>
            </cell>
          </div>
        }

        <!-- Income Generating Asset -->
        @if (loanPurpose.isIncomeGeneratingAsset !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Income Generating Asset</div>
              <div body>{{booleanToYesNo(loanPurpose.isIncomeGeneratingAsset)}}</div>
            </cell>
          </div>
        }
        
        <!-- Expected Monthly Income -->
        @if (loanPurpose.expectedMonthlyIncome !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Expected Monthly Income</div>
              <div body>{{loanPurpose.expectedMonthlyIncome | looseCurrency}}</div>
            </cell>
          </div>
        }

        <!-- Existing Finance Commitments -->
        @if (loanPurpose.hasExistingFinanceCommitments !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Asset has an existing finance commitment</div>
              <div body>{{booleanToYesNo(loanPurpose.hasExistingFinanceCommitments)}}</div>
            </cell>
          </div>
        }

        <!-- Lender -->
        @if (loanPurpose.lender !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Lender</div>
              <div body>{{loanPurpose.lender}}</div>
            </cell>
          </div>
        }

        <!-- Loan Value -->
        @if (loanPurpose.loanValue !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Loan Value</div>
              <div body>{{loanPurpose.loanValue | looseCurrency}}</div>
            </cell>
          </div>
        }

        <!-- Tax Balance -->
        @if (loanPurpose.taxBalance !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Tax Balance</div>
              <div body>{{loanPurpose.taxBalance | looseCurrency}}</div>
            </cell>
          </div>
        }

        <!-- Purchase Price -->
        @if (loanPurpose.purchasePrice !== undefined) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Purchase Price</div>
              <div body>{{loanPurpose.purchasePrice | looseCurrency}}</div>
            </cell>
          </div>
        }

        <!-- Renewal (specifically for Limit Changes) -->
        @if (termRenewal !== null) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Renewal</div>
              <div body>{{booleanToYesNo(termRenewal)}}</div>
            </cell>
          </div>
        }
      </div>
    } @else {
      <!-- Simple case: just show the loan purpose name -->
      <div class="row" [ngClass]="{'needPadding': needPadding}">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Loan Purpose</div>
            <div body>{{loanPurpose.name}}</div>
          </cell>
        </div>
        
        <!-- Renewal (specifically for Limit Changes) -->
        @if (termRenewal !== null) {
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Renewal</div>
              <div body>{{booleanToYesNo(termRenewal)}}</div>
            </cell>
          </div>
        }
      </div>
    }
  }
</div> 